<template>
  <p :class="['font-mono text-xs uppercase tracking-widest', toneClass]">
    <slot />
  </p>
</template>

<script setup lang="ts">
import { computed } from 'vue'

type Tone = 'muted' | 'clay' | 'on-dark'

const props = withDefaults(defineProps<{
  tone?: Tone
}>(), {
  tone: 'muted',
})

const toneMap: Record<Tone, string> = {
  muted:    'text-muted',
  clay:     'text-clay-700',
  'on-dark': 'text-cream-300',
}

const toneClass = computed(() => toneMap[props.tone])
</script>
